import type { MiddlewareAPI } from 'redux';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import type { ActionsObservable } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type { FieldCollection } from '../../model/types.tsx';
import { getRelatedIssues } from '../../services/related-issues/index.tsx';
import {
	GET_RELATED_ISSUES_COUNT,
	setRelatedIssuesCount,
	deletionFailure,
} from '../../state/actions.tsx';
import { getVersionId } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';

const LOG_LOCATION = 'project-directories.versions.delete-version.ops.get-related-issues-count';

export const epic = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action$: ActionsObservable<any>,
	store: MiddlewareAPI<State>, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> =>
	action$.ofType(GET_RELATED_ISSUES_COUNT).mergeMap(() =>
		Observable.fromPromise(getRelatedIssues(getVersionId(store.getState())))
			.map((relatedIssues: FieldCollection) => setRelatedIssuesCount(relatedIssues))
			.catch((error) => {
				log.safeErrorWithoutCustomerData(LOG_LOCATION, error.message, error);
				return Observable.of(deletionFailure(error));
			}),
	);
